import PageTitle from "../include/PageTitle";
import Tech_ul from "../include/Tech_ul";

const RapidAppInnovative = ({title}) => {
    return (
        <>
            <PageTitle title={title}/>

            <section className="service-details-page">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-4 col-lg-5">
                            <div className="service-details-sidebar-box">
                                {/*Start Single Sidebar Box*/}
                                <div className="single-sidebar-box single-sidebar__service">
                                    <div className="title-box">
                                        <h2>Our Service</h2>
                                        <div className="border-line"/>
                                    </div>
                                    <Tech_ul/>
                                </div>
                                {/*End Single Sidebar Box*/}
                                {/*Start Single Sidebar Box*/}
                                <div className="single-sidebar-box single-sidebar__contact">
                                    <div
                                        className="single-sidebar__contact-bg"
                                        style={{
                                            backgroundImage:
                                                "url(assets/img/resource/sidebar-phone-number-box-bg.jpg)"
                                        }}
                                    ></div>
                                    <div className="single-sidebar__contact-box">
                                        <div className="icon-box">
                                            <span className="icon-call"/>
                                        </div>
                                        <div className="text-box text-center">
                                            <p>Need help? contact our experts</p>
                                            <a href="tel:2512353256">+0032-1255-69874</a>
                                        </div>
                                    </div>
                                </div>
                                {/*End Single Sidebar Box*/}
                                {/*Start Single Sidebar Box*/}
                                <div className="single-sidebar-box single-sidebar__search">
                                    <div className="title-box">
                                        <h2>Search Service</h2>
                                        <div className="border-line"/>
                                    </div>
                                    <form className="search-form" action="#">
                                        <input placeholder="Search..." type="text"/>
                                        <button className="button-style-1" type="submit">
                                            Search
                                        </button>
                                    </form>
                                </div>
                                {/*End Single Sidebar Box*/}
                                {/*Start Sidebar Quote Box*/}
                                <div className="sidebar-quote-box">
                                    <div className="text-box">
                                        <p>
                                            Aliquam eros justo, posuere loborti vive rra laoreet matti
                                            ullamc per posu ere of the viverra .Aliquam os justo, posuere
                                            non, vive rra oreet augue mattis ullam corper viverra laoreet
                                            vive
                                        </p>
                                        <span className="icon-quote22 icon"/>
                                    </div>
                                    <div className="bottom-box">
                                        <div className="img-box">
                                            <img src="assets/img/resource/sidebar-quote.png" alt=""/>
                                        </div>
                                        <div className="title-box">
                                            <h2>Darliana shimp</h2>
                                            <p>Manager</p>
                                        </div>
                                    </div>
                                </div>
                                {/*End Sidebar Quote Box*/}
                            </div>
                        </div>
                        {/*Start Service Details Page Content*/}
                        <div className="col-xl-8 col-lg-7">
                            <div className="service-details__content">
                                <div className="service-details__content-img1">
                                    <img src="assets/img/service/service-details-4.jpg" alt=""/>
                                    <div className="icon-box">
                                        <span className="icon-power"/>
                                    </div>
                                </div>
                                <div className="service-details__content-text1">
                                    <p>
                                        Aliquam eros justo, posuere loborti viverra lao ullamcorper
                                        posuere viverra .Aliquam eros justo, posuere lobortis non, viverra
                                        laoreet augue mattis start fermentum ullamcor viverra laoreet By
                                        Admin . Creativity . 28th February 2022 . Leave a comment viverra
                                        laoreet augue mattis start fermentum start fermentum ullamcor
                                        laoreet augue mattis start fermentum ullamcor viverra laoreet.
                                    </p>
                                    <p>
                                        Aliquam eros justo, posuere loborti viverra lao ullamcorper
                                        posuere viverra .Aliquam eros justo, posuere lobortis non, viverra
                                        laoreet augue mattis start fermentum ullamcor viverra laoreet By
                                        Admin . Creativity . 28th February 2022 . Leave a comment viverra
                                        laoreet augue mattis start fermentum start fermentum{" "}
                                    </p>
                                </div>
                                <div className="service-details__content-text2">
                                    <div className="row">
                                        <div className="col-xl-6 col-lg-12 col-md-6">
                                            <div className="service-details__content-text2-img">
                                                <img src="assets/img/service/service-details-2.jpg" alt=""/>
                                            </div>
                                        </div>
                                        <div className="col-xl-6 col-lg-12 col-md-6">
                                            <div className="content-box">
                                                <div className="single-content">
                                                    <h4>
                                                        <span className="icon-checklist-2"/> Best Emplementation
                                                    </h4>
                                                    <p>
                                                        ished fact that a reader will be distrol acted bioiiy
                                                        desig ished fact that a reader will acted bioiiy desig.
                                                    </p>
                                                </div>
                                                <div className="single-content mb0">
                                                    <h4>
                                                        <span className="icon-checklist-2"/> Best Emplementation
                                                    </h4>
                                                    <p>
                                                        ished fact that a reader will be distrol acted bioiiy
                                                        desig ished fact that a reader will acted bioiiy desig.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="service-details__content-text3">
                                    <p>
                                        Aliquam eros justo, posuere loborti viverra lao ullamcorper
                                        posuere viverra .Aliquam eros justo, posuere lobortis non, viverra
                                        laoreet augue mattis start fermentum ullamcor viverra laoreet By
                                        Admin . Creativity . 28th February 2022 . Leave a comment viverra
                                        laoreet augue mattis start fermentum start fermentum{" "}
                                    </p>
                                </div>
                                <div className="service-details__content-text4">
                                    <div className="content-box">
                                        <div className="content-box-single">
                                            <h4>Best Emplementation</h4>
                                            <p>
                                                ished fact that a reader will be distrol acted bioiiy desig
                                                the.ished fact that a reader will be distrol acted bioiiy
                                                bioiiy desig the.ished fact that a reader.
                                            </p>
                                        </div>
                                        <div className="content-box-single">
                                            <h4>Design make for you.</h4>
                                            <p>
                                                ished fact that a reader will be distrol acted bioiiy desig
                                                the.ished fact that a reader will be distrol acted bioiiy
                                                bioiiy desig the.ished fact that a reader.
                                            </p>
                                        </div>
                                        <div className="content-box-single mb">
                                            <h4>Finished the process</h4>
                                            <p>
                                                ished fact that a reader will be distrol acted bioiiy desig
                                                the.ished fact that a reader will be distrol acted bioiiy
                                                bioiiy desig the.ished fact that a reader.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="img-box">
                                        <img src="assets/img/service/service-details-3.jpg" alt=""/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/*End Service Details Page Content*/}
                    </div>
                </div>
            </section>

        </>
    )
}
export default RapidAppInnovative